module.exports = __webpack_public_path__ + "static/media/ConsistentNight.5b795928.png";